module.exports = __webpack_public_path__ + "static/media/zhangbozhi.b6da5a35.png";